import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  style: {"display":"inline-block"},
  class: "col-12"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, " WebAPIの設定 ", -1)
const _hoisted_7 = {
  class: "col-8 offset-2 card",
  style: {"position":"fixed","z-index":"99","padding":"2%","background":"lightgray"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, " Access Key ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { style: {"position":"static","text-align":"right","width":"100%","display":"inline-block"} }
const _hoisted_13 = { class: "col-8 offset-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, " 有効期限 ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "IndefinitePeriod" }, "無期限", -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("small", null, "集計データを取得する ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("small", null, "間隔内の最初のデータを取得する ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("small", null, "未加工のデータ取得する ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("small", null, "最後に到達したデータのテーブルを利用する ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h3", null, " SQLの作成 ", -1)
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "offset-2 col-6" }
const _hoisted_33 = {
  style: {"text-align":"left"},
  class: "col-2"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { class: "col-12" }
const _hoisted_36 = ["src"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateSelector = _resolveComponent("DateSelector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createTextVNode(" 初回の登録時のみ表示されます。キーは安全に保管してください。 "),
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              ref: "apikey",
              readonly: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.savedApiKey) = $event)),
              style: {"cursor":"pointer"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.apikeyToClipboard())),
              class: "card col-10 offset-1"
            }, null, 512), [
              [_vModelText, this.savedApiKey]
            ]),
            _hoisted_11,
            _createElementVNode("button", {
              class: "offset-4 col-4 btn btn-dark",
              onClick: _cache[2] || (_cache[2] = ($event: any) => {this.savedApiKey = false ;})
            }, " 閉じる ")
          ], 512), [
            [_vShow, false!=_ctx.savedApiKey]
          ]),
          _createElementVNode("span", _hoisted_12, [
            _withDirectives(_createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteSetting())),
              class: "btn btn-danger"
            }, "削除", 512), [
              [_vShow, this.$route.query.id]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.setting.path) = $event)),
              placeholder: "API Name",
              class: "form-control col-12 card"
            }, null, 512), [
              [_vModelText, _ctx.setting.path]
            ]),
            _hoisted_14,
            _hoisted_15,
            _createTextVNode(),
            _hoisted_16,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.setting.dateOfExpiry) = $event)),
              class: "form-select",
              "aria-label": "Default select example"
            }, [
              _hoisted_17,
              _createElementVNode("option", null, _toDisplayString(_ctx.getMoment().add("month", 3).format("YYYY-MM-DD")), 1),
              _createElementVNode("option", null, _toDisplayString(_ctx.getMoment().add("years", 1).format("YYYY-MM-DD")), 1),
              (_ctx.setting.dateOfExpiry!='IndefinitePeriod')
                ? (_openBlock(), _createElementBlock("option", _hoisted_18, _toDisplayString(_ctx.setting.dateOfExpiry), 1))
                : _createCommentVNode("", true)
            ], 512), [
              [_vModelSelect, _ctx.setting.dateOfExpiry]
            ]),
            _hoisted_19,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.setting.sensorIDs) = $event)),
              placeholder: "対象のセンサ",
              class: "form-control col-12 card"
            }, null, 512), [
              [_vModelText, _ctx.setting.sensorIDs]
            ]),
            _hoisted_20,
            _withDirectives(_createElementVNode("input", {
              class: "form-control-input",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.setting.needAggregateData) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.setting.needAggregateData]
            ]),
            _createTextVNode(),
            _hoisted_21,
            _hoisted_22,
            _withDirectives(_createElementVNode("input", {
              class: "form-control-input",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.setting.needFirstData) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.setting.needFirstData]
            ]),
            _hoisted_23,
            _hoisted_24,
            _withDirectives(_createElementVNode("input", {
              class: "form-control-input",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.setting.needRawData) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.setting.needRawData]
            ]),
            _createTextVNode(),
            _hoisted_25,
            _hoisted_26,
            _withDirectives(_createElementVNode("input", {
              class: "form-control-input",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.setting.needLatestData) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.setting.needLatestData]
            ]),
            _createTextVNode(),
            _hoisted_27,
            _hoisted_28
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_DateSelector, {
                  ref: "dateselector",
                  sensorIDs: _ctx.sensorIDs,
                  showGranularitySelector: true
                }, null, 8, ["sensorIDs"])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  class: "btn btn-dark",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateData()))
                }, "データの取得")
              ])
            ]),
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("iframe", {
                class: "col-12 d-view-iframe",
                loading: "lazy",
                style: {"height":"420px","width":"100%"},
                src: _ctx.view.src
              }, null, 8, _hoisted_36)
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveSetting())),
            class: "btn btn-success"
          }, "WebAPIの更新"),
          _hoisted_37,
          _hoisted_38,
          _hoisted_39,
          _createElementVNode("button", {
            onClick: _cache[13] || (_cache[13] = ($event: any) => { this.$router.push('/api/designer/');}),
            class: "btn btn-dark"
          }, "戻る")
        ]),
        _hoisted_40,
        _hoisted_41,
        _createTextVNode(),
        _hoisted_42
      ])
    ])
  ]))
}